import React, { useState, useEffect } from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";

import BalanceDataTables from "./DataTables";
import { toShamsiDate } from "../parity/AriaReport";

const TRANSACTION_TYPE_MAP = {
  "1": "revenues",
  "2": "expenses",
  revenues: "revenues",
  expenses: "expenses",
};

const resolveReportDate = (dateParam) => {
  if (dateParam) return dateParam;
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
};

const DailyReportTransactions = ({ match }) => {
  const { date: dateParam, type, id } = match.params;
  const date = resolveReportDate(dateParam);
  const shamsiDate = toShamsiDate(date);

  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];

  const transactionType = TRANSACTION_TYPE_MAP[type] || type;
  const isRevenue = transactionType === "revenues";

  let _bodyTitle = {
    mainTitle: isRevenue ? "درآمد ها" : "مصارف ها",
  };

  const [tableData, setTableData] = useState([]);
  const [transaction, setTransaction] = useState(null);
  const [bodyTitle, setBodyTitles] = useState(_bodyTitle);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    requestData();
  }, []);

  const requestData = async () => {
    try {
      if (!TRANSACTION_TYPE_MAP[type] && type !== "revenues" && type !== "expenses") {
        setLoadError(true);
        return;
      }

      const typesResponse = await db.getAll(`${transactionType}/types`);
      const typeList = typesResponse?.data?.data ?? [];
      const selectedType = typeList.find((trans) => String(trans.id) === String(id));

      if (!selectedType) {
        setLoadError(true);
        return;
      }

      setBodyTitles({
        ..._bodyTitle,
        subTitle: selectedType.name,
      });
      setTransaction(selectedType);

      const dailyResponse = await db.getAll(
        `dashboard/finance/daily?date=${date}`
      );
      const dailyRows = dailyResponse?.data?.data?.[0]?.[transactionType] ?? [];
      setTableData(dailyRows);
      setLoadError(false);
    } catch (error) {
      setTableData([]);
      setLoadError(true);
    }
  };

  const filteredCount = Array.isArray(tableData)
    ? tableData.filter((row) =>
        isRevenue
          ? row.revenue_type_id === parseInt(id, 10)
          : row.expense_type_id === parseInt(id, 10)
      ).length
    : 0;

  return (
    <main className="main-print-wrapper daily-transactions-print">
      <PrintHeader
        title={lbl.DailyReport}
        date={date}
        shamsiDate={shamsiDate}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={bodyTitle} />
      {loadError ? (
        <p className="daily-report-empty-note">
          گزارش روزانه برای این نوع یا تاریخ در دسترس نیست.
        </p>
      ) : filteredCount === 0 ? (
        <p className="daily-report-empty-note">
          برای این تاریخ و نوع تراکنش، رکوردی ثبت نشده است.
        </p>
      ) : (
        <BalanceDataTables
          typeID={id}
          name={transaction?.name_en}
          data={tableData}
          typeName={isRevenue ? "revenue_type_id" : "expense_type_id"}
        />
      )}
    </main>
  );
};

export default DailyReportTransactions;
